module.exports = __webpack_public_path__ + "img/home-hero-pattern-top.cef0035b.png";